/* ====== External Dependencies */
var Modernizr = require('sonder/modernizr')

import Glide from '@glidejs/glide'
import 'lazysizes'

/* POLYFILLS */
import 'objectFitPolyfill'
import smoothscroll from 'smoothscroll-polyfill'
import 'nodelist-foreach-polyfill'
/* end POLYFILLS */
/* === end External Dependencies */

import { default as ScrollHandler } from 'sonder/scroll'
import { default as PreloadClassHandler } from 'sonder/preload'
import { default as Hamburger } from 'sonder/hamburger'
import { default as HideOnScroll } from 'sonder/hideOnScroll'
import { default as ParallaxImages } from 'sonder/parallaxImage'
import { default as SearchToggle } from 'sonder/searchToggle'
import { default as MobileNavActivator } from 'sonder/mobileNavActivator'
import { default as SubMenuToggles, SubMenuFlipper } from 'sonder/subMenus'
import { default as GoogleMaps } from 'sonder/locations'
import { default as AccessibilityOptions } from 'sonder/accessibility'
import { default as ResizeHandler } from 'sonder/resize.js'

import 'sonder/video.js'

smoothscroll.polyfill()
if (!Modernizr.objectfit) {
    window.objectFitPolyfill()
}

if (!Modernizr.svg) {
    /* TODO: actually implement a fallback
    $('img[src*="svg"]').attr('src', function() {
      return $(this).attr('src').replace('.svg', '.png');
    });
*/
}

PreloadClassHandler.init()
let scrollHandler = new ScrollHandler()
document.addEventListener('DOMContentLoaded', () => {
    // initialize any scroll #id related things
    scrollHandler.scrollToUrl()
    scrollHandler.initScrollLinks()

    // init header hiding
    const header = new HideOnScroll(true)
    header.init(document.querySelector('.navWrap'))

    // init hamburger animation toggle
    Hamburger.init()

    // init search toggle
    SearchToggle.init()
    MobileNavActivator.init()

    // initialize parallax image effect
    ParallaxImages()

    // init the mobile submenu toggles
    SubMenuToggles()
    
    // initialize the maps
    GoogleMaps()

    // initialize the sub menu flipping on desktop
    SubMenuFlipper()

    // initialize accessibility options
    AccessibilityOptions()

    // resize handler
    ResizeHandler.init()

    //-- CSS Viewport Variable Creation --//
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    var vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    // init the glide.js card sliders
    const cardSliderOptions = {
        type: 'slider',
        startAt: 0,
        perView: 3,
        gap: 30,
        bound: true,
        peek: {
            before: 0,
            after: 75
        },
        breakpoints: {
            768: {
                perView: 1
            },
            1024: {
                perView: 2
            },
            1200: {
                perView: 3
            },
            1400: {
                perView: 3
            },
            1600: {
                perView: 4
            },
            1800: {
                perView: 4
            },
            4000: {
                perView: 4
            }
        }
    }

    const sliders = document.querySelectorAll('.glide')
    sliders.forEach((slider) => {
        let sliderObj = new Glide(slider, cardSliderOptions).mount()
        let slides = slider.querySelectorAll('.glide__slide')
        
        // disable sliding on desktop 
        if(slides.length < 4) {
            //sliderObj.disable()
            let arrows = slider.querySelector('.glide__arrows')
            if(arrows) {
                arrows.classList.add('is-hidden-desktop')
            }
        }

        ResizeHandler.addWidthResizeListener(() => {
            sliderObj.go('<<')
        })
    })

    const faqs = document.querySelectorAll('.faqs .faq')
    faqs.forEach((faq) => {
        const question = faq.querySelector('.question')
        const button = faq.querySelector('.question button.collapse')
        const answer = faq.querySelector('.answer')
        const height = answer.getBoundingClientRect().height

        answer.classList.add('hidden')

        question.addEventListener('click', (e) => {
            if(answer.classList.contains('hidden')) {
                answer.classList.remove('hidden')
                answer.style['max-height'] = `${height}px`
                button.classList.add('collapsed')
            }
            else {
                answer.classList.add('hidden')
                answer.style['max-height'] = '0px'
                button.classList.remove('collapsed')
            }
        })
    })

    window.contentSectionButtons = function () {
        let edits = document.querySelectorAll('.contentSectionEdit')
        edits.forEach((editButton) => {
            editButton.classList.toggle('is-hidden')
        })
    }


    let cardResizeTimeout;
    let adjustCardHeight = () => {
        let doubleCards = document.querySelectorAll('.doubleCards .imageCard')
        let tallest = 0

        doubleCards.forEach((card) => {
            card.style.height = 'auto'
        })

        if(cardResizeTimeout) {
            clearTimeout(cardResizeTimeout)
        }
        
        cardResizeTimeout = setTimeout(() => {
            doubleCards.forEach((card) => {
                if(card.getBoundingClientRect().height > tallest) {
                    tallest = card.getBoundingClientRect().height
                }
            })
        
            doubleCards.forEach((card) => {
                card.style.height = tallest + "px"
            })
        }, 100)
    }

    adjustCardHeight()
    // force cards to be same height
    window.addEventListener('resize', () => {
        adjustCardHeight()
    })

})
